import { useTranslation } from 'react-i18next';
import { FacebookOutlined, MailOutlined } from '@ant-design/icons';
import { handleEmailContact } from '../../utils/emailContact';

const PublicFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer style={{ background: '#1a1a2e', color: '#ccc' }}>
      <div style={{
        maxWidth: 1100,
        margin: '0 auto',
        padding: '56px 4vw 40px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: 40,
        alignItems: 'start',
      }}>
        {/* Brand */}
        <div>
          <img
            src="/images/landing/logo.png"
            alt="Hanwen Chinese"
            style={{ height: 48, marginBottom: 12 }}
          />
          <h3 style={{
            color: '#fff',
            fontSize: 18,
            fontWeight: 700,
            fontFamily: "'Space Grotesk', sans-serif",
            margin: '0 0 8px',
          }}>
            {t('landing.footer.brandName')}
          </h3>
          <p style={{
            color: '#888',
            fontSize: 13.5,
            fontFamily: "'Lora', serif",
            lineHeight: 1.6,
            margin: 0,
          }}>
            {t('landing.footer.tagline')}
          </p>
        </div>

        {/* Contact */}
        <div>
          <h4 style={{
            color: '#fff',
            fontSize: 14,
            fontWeight: 600,
            fontFamily: "'Space Grotesk', sans-serif",
            margin: '0 0 12px',
            textTransform: 'uppercase',
            letterSpacing: 1,
          }}>
            {t('landing.footer.contact')}
          </h4>
          <a
            href="#contact"
            onClick={handleEmailContact}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              color: '#bbb',
              fontFamily: "'Lora', serif",
              fontSize: 14.5,
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = '#bbb'; }}
          >
            <MailOutlined />
            admin@hanwenchinese.com
          </a>
        </div>

        {/* Social */}
        <div>
          <h4 style={{
            color: '#fff',
            fontSize: 14,
            fontWeight: 600,
            fontFamily: "'Space Grotesk', sans-serif",
            margin: '0 0 12px',
            textTransform: 'uppercase',
            letterSpacing: 1,
          }}>
            {t('landing.footer.social')}
          </h4>
          <a
            href="https://www.facebook.com/hanwenchinese"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              color: '#03a5da',
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: 14.5,
              fontWeight: 500,
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = '#05b8f0'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = '#03a5da'; }}
          >
            <FacebookOutlined style={{ fontSize: 18 }} />
            Facebook
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        textAlign: 'center',
        padding: '18px 4vw',
        borderTop: '1px solid #2d2d42',
        color: '#666',
        fontFamily: "'Lora', serif",
        fontSize: 12.5,
      }}>
        &copy; {new Date().getFullYear()} Hanwen Chinese. All rights reserved.
      </div>
    </footer>
  );
};

export default PublicFooter;
